import Alpine from "alpinejs";
import "./styles/index.css";
import { autoFocus, trapTab } from "./lib/focus-trap";
import { createAppStore } from "./stores/app";
import { createBoardStore, type BoardStore } from "./stores/board";
import { createUIStore } from "./stores/ui";
import { createSessionStore, type SessionStore } from "./stores/session";
import { showcaseHTML, showcaseAlpine } from "./views/showcase";
import { demoShellHTML } from "./views/demo-shell";
import { demoBannerAlpine } from "./views/demo-banner";
import { scheduleAlpine } from "./views/schedule-data";
import { bookingModalAlpine } from "./views/booking-data";
import { dispatchAlpine } from "./views/dispatch-data";
import { progressAlpine } from "./views/progress-data";
import { feedbackAlpine } from "./views/feedback-data";
import { loginHTML, loginAlpine } from "./views/auth";

declare global {
  interface Window {
    Alpine: typeof Alpine;
    autoFocus: typeof autoFocus;
    trapTab: typeof trapTab;
  }
}

window.Alpine = Alpine;
window.autoFocus = autoFocus;
window.trapTab = trapTab;

Alpine.store("app", createAppStore());
Alpine.store("board", createBoardStore());
Alpine.store("ui", createUIStore());
Alpine.store("session", createSessionStore());

const boardStore = Alpine.store("board") as BoardStore;
const sessionStore = Alpine.store("session") as SessionStore;

Alpine.data("showcase", showcaseAlpine);
Alpine.data("demoBanner", demoBannerAlpine);
Alpine.data("schedule", scheduleAlpine);
Alpine.data("bookingModal", bookingModalAlpine);
Alpine.data("dispatch", dispatchAlpine);
Alpine.data("progress", progressAlpine);
Alpine.data("feedback", feedbackAlpine);
Alpine.data("login", loginAlpine);

const root = document.getElementById("root");
if (root) {
  root.innerHTML = `
    <div x-data x-show="$store.app.view === 'showcase'" style="display: contents">
      ${showcaseHTML()}
    </div>
    <div x-data x-show="$store.app.view === 'app'" style="display: contents">
      ${demoShellHTML()}
    </div>
    <div x-data x-show="$store.app.view === 'login'" style="display: contents">
      ${loginHTML()}
    </div>
  `;
}

Alpine.start();

(async () => {
  try {
    await sessionStore.init();
  } catch (e) {
    console.warn("[session.init] failed, falling back to demo:", (e as Error).message);
  }
  if (sessionStore.status === "authed" && sessionStore.profile?.schoolId) {
    await boardStore.loadForSchool(sessionStore.profile.schoolId);
    if (sessionStore.profile.role) {
      boardStore.role = sessionStore.profile.role as typeof boardStore.role;
    }
  } else {
    await boardStore.loadDemo();
  }
})();
